import React from 'react';
import './bootcamp.css';

const b_wywl2 = () => {
    const state = {
        wywl_item: [
            {
                title: `Beginners`,
                list: [
                    {
                        text: `Beginners pursuing data science careers`,
                    },
                    {
                        text: `Those trying to decide on the right data science path`,
                    },
                    {
                        text: `Business Analysts and Data Analysts seeking new skills`,
                    },
                ],
            },
            {
                title: `Intermediates`,
                list: [
                    {
                        text: `Data Scientists`,
                    },
                    {
                        text: `Data Engineers`,
                    },
                    {
                        text: `ML Engineers`,
                    },
                    {
                        text: `Software Engineers`,
                    },
                ],
            },
            {
                title: `Citizens`,
                list: [
                    {
                        text: `Citizen Data Scientists`,
                    },
                    {
                        text: `Data Wranglers`,
                    },
                    {
                        text: `Data Science 4 Good`,
                    },
                    {
                        text: `Data Journalists`,
                    },
                ],
            },
      ],
    };

    const renderTrack = (item, i) => {
        return (
            <div className='b_tracks--block b_wywl2--block'>
                <h4 className='b_tracks--block_title'>{item.title}</h4>
                <ul className='b_tracks--list' key={`b_track-${i}`}>
                    {item.list.map(item => {
                        return (
                            <li className='b_tracks--list_item'>{item.text}</li>
                        )
                    })}
                </ul>
            </div>
        );
    };

    return (
        <div className="m_wywl__wrap">
            <div className="m_wywl container">
                <h3 className="m_wywl--title">Who Should Attend</h3>
                <div className='b_tracks--blocks'>
                    {state.wywl_item.map((item, i) => renderTrack(item, i))}
                </div>
            </div>
        </div>
    );
};

export default b_wywl2;